import { useEffect, useState } from 'react';
import { STATS, STATS_SOURCES } from '../../data/siteData';
import { prefersReducedMotion, useInViewOnce } from '../../hooks/useMotion';

const CountUp = ({ to, run }) => {
  const [value, setValue] = useState(to);

  useEffect(() => {
    if (!run || prefersReducedMotion()) return undefined;
    let frame;
    let start;
    const step = (t) => {
      if (!start) start = t;
      const k = Math.min(1, (t - start) / 1400);
      setValue(Math.round(to * (1 - Math.pow(1 - k, 3))));
      if (k < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [to, run]);

  return value;
};

export const StatsStrip = () => {
  const [ref, inView] = useInViewOnce(0.35);
  const animate = !prefersReducedMotion();

  return (
    <section className="strip" ref={ref} data-testid="stats-section">
      <div className="wrap">
        <div className="mono light">The problem</div>
        <h2>Construction is changing. Is your team ready?</h2>
        <div className="row">
          {STATS.map((s) => (
            <div className="st" key={s.source}>
              <span className="num">
                <CountUp to={s.value} run={inView} />
                <sup>%</sup>
              </span>
              <div className="bar">
                <i style={{ width: !animate || inView ? `${s.value}%` : 0 }} />
              </div>
              <p>{s.text}</p>
              <small>{s.source}</small>
            </div>
          ))}
        </div>
        <div className="foot">
          <p>BuildiTech helps project teams reduce these risks through BIM coordination, structured documentation and digital collaboration.</p>
          <small>{STATS_SOURCES}</small>
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
